import { render } from "./WheelPointerPositionField.vue?vue&type=template&id=8cc254f8&scoped=true"
import script from "./WheelPointerPositionField.vue?vue&type=script&lang=ts"
export * from "./WheelPointerPositionField.vue?vue&type=script&lang=ts"

import "./WheelPointerPositionField.vue?vue&type=style&index=0&id=8cc254f8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8cc254f8"

export default script